'use client'

import { Cell, Icon, Spacer } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import type { BulletPoint } from '../newContentTestConfig'

type Props = {
  bulletPoints: Array<BulletPoint>
  iconColor?: React.ComponentProps<typeof Icon>['color']
}

export const BulletPointList = ({
  bulletPoints,
  iconColor = Icon.Color.GreyscaleLevel2,
}: Props) => {
  const translate = useTranslate('conversation.phishing_first_time_lister_education')

  return (
    <>
      <Spacer size={Spacer.Size.X2Large} />
      <div className="u-flexbox u-flex-direction-column u-align-items-start">
        {bulletPoints.map(({ text, icon }) => (
          <div
            key={text}
            className="u-flexbox u-align-items-center u-margin-bottom-medium u-padding-vertical-small"
          >
            <Cell
              prefix={<Icon name={icon} color={iconColor} />}
              title={translate(text)}
              styling={Cell.Styling.Tight}
            />
          </div>
        ))}
      </div>
    </>
  )
}
